import $ from 'jquery';

export default function topButton (buttonId) {
    window.onscroll = function() {
	    const btn = document.getElementById(buttonId);
	    if(btn) {
	    	if (pageYOffset > 450) {
		    	btn.classList.add('visible');
		    	btn.classList.remove('hidden');
		    } else if(pageYOffset <= 450) {
		    	btn.classList.add('hidden');
		    	btn.classList.remove('visible');
		    }
	    }
	}
}